import { ChargeNote } from './../../services/supplier-bill.service';
import { Remission } from './../../services/remission.service';
import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { CustomerBillService, CustomerBillFilter } from '../../services/customer-bill.service';
import { IncomedBill } from '../../services/income.service';
import { PermissionService, SpecialPermissions } from '../../services/permission.service';
import { AuthService } from '../../services/auth.service';
import { Router } from '@angular/router';
import { Utils } from '../../util';
import { PdfTemplates } from '../../pdfTemplates';
import { Pdf } from '../../coms';
import { toast } from 'angular2-materialize';


@Component({
  selector: 'app-read-expiration',
  templateUrl: './read-expiration.component.html',
  styleUrls: ['./read-expiration.component.css']
})
export class ReadExpirationComponent implements OnInit {
  allowed: boolean = false;
  permission: Partial<{[K in keyof typeof SpecialPermissions]: boolean}> = {};

  customerBills: any[] = [];
  filteredBills: any[] = [];

  subs: Subscription[] = [];

  constructor(
    private service: CustomerBillService,
		private permissionService: PermissionService,
    private authService: AuthService,
    private router: Router
  ) {
    let permissionsSubs = this.permissionService.getUserPermissionByEmail(this.authService.currentUser['email']).subscribe((groups) => {
        permissionsSubs.unsubscribe();
        this.permission = this.permissionService.constructPermissionObject(groups, 'SPECIAL');
        if(!this.permission || !this.permission.customerBillExpiration){
          toast('No tiene permisos.', 3000);
          this.router.navigate(['/']);
        }
        else this.allowed = true;
    });

    this.subs[0] = this.service.getCustomerBills().subscribe(tempCustomerBills => {
      this.customerBills = tempCustomerBills.map(customerBill => {
        let {id, folio, status='key0'} = customerBill;
        if(status == 'key99'){
          console.log(`Canceled bill avoided: ${id}, ${folio}`);
          return null;
        }
        let incomed = new IncomedBill(customerBill);
        let [py, pm, pd] = customerBill.payDate.split('-');
        customerBill.customerName = customerBill.customerObj.name;
        customerBill.residue = incomed.residue;
        customerBill.money_residue = this.money(customerBill.residue);
        customerBill.money_total = this.money(customerBill.totals.total);

        let days = Math.ceil((new Date(py, pm - 1, pd).getTime() - new Date().getTime()) / (24*60*60*1000));
        customerBill.days = days;
        customerBill.column = days < 0 ? 0 : days < 8 ? 1 : days < 15 ? 2 : days < 22 ? 3 : 4;
        return !incomed.isComplete && customerBill;
      }).filter(b => b);
      this.filterBar = new CustomerBillFilter(this.customerBills, {});
      this.applyFilterBar();
    });
  }

  ngOnInit() {
  }


  money = Utils.money;

  ////////////////////////////////////////////////////////////////////FilterBar
  filterBar: CustomerBillFilter = new CustomerBillFilter([], {});
  applyFilterBar(){
    this.filteredBills = this.filterBar.filteredData;
  }
  ////////////////////////////////////////////////////////////////////FilterBar

  columns: string[] = ['Cliente', 'Folio', 'Fecha', 'Fecha pago', 'Monto', 'Saldo', 'Vencido', '1 - 7', '8 - 14', '15 - 21', '+22'];
  onCSV(){
    let rows = [
      this.columns,
      ...this.filteredBills.map(({customerName:cn, folio:f, date:d, payDate:pd, money_total:mt, money_residue:mr, column:col}) => {
        return { cn, f, d, pd, mt, mr, l0: col == 0 ? mr : '', l1: col == 1 ? mr : '', l2: col == 2 ? mr : '', l3: col == 3 ? mr : '', l4: col == 4 ? mr : '' }
      })
    ]
    Utils.downloadExcel(rows, `VencimientoSaldosCliente${this.filterBar.customerSelect[this.filterBar.customerIndex].name}`.replace(/ /g, '_'));
  }

  
  onPdfExport(){
    
    function formatNumber(num) {
      return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
    }

    let totalsRow = {folio: '', fechas: '', fechas2: '', dias: '', dias2: '', vencido: '0',  por_vencer: '0', por_vencer2: '0', por_vencer3: '0', por_vencer4: '0', saldo_total: '0' }
    let totalSum: number
    let rows: {[cName: string]: any[]} = {};
    let sumRow: {[cName: string]: any[]} = {};
    this.filteredBills.map(({customerName:cn, folio, date:fechas, payDate:fechas2, money_total, money_residue:vencido, column:col, days}) => {
      if(!rows[cn]) rows[cn] = []; {
        rows[cn].push({ cn, folio, fechas, fechas2, dias: days < 0 ? -days : '', dias2:  days >= 0 ? `${days}` : '', saldo_total: vencido, vencido: col == 0 ? vencido : '', por_vencer: col == 1 ? vencido : '', por_vencer2: col == 2 ? vencido : '', por_vencer3: col == 3 ? vencido : '', por_vencer4: col == 4 ? vencido : '' })
        totalSum = Utils.strToNumber(totalsRow.saldo_total)
        totalsRow.saldo_total = this.money(Utils.strToNumber(totalsRow.saldo_total) + Utils.strToNumber(vencido));

          console.log(Utils.strToNumber(totalsRow.saldo_total));
          console.log('TotalSum', totalSum);
        
      }

      
      
    })
    // totalSum = 0

    let sumRows: {[customerName: string]: any[]} = {};
    for (const key in rows) {

      // sumRows[key]

      

      let rowTotals: number
      let columnTotals: number[]

      let vencidoSum: number = 0
      let xVencer07: number = 0
      let xVencer814: number = 0
      let xVencer1521: number = 0
      let xVencer22: number = 0
      let totalSum: number = 0


      let dataArray = rows[key]

      dataArray.forEach(rowData => {

        let vencidoSumCache = vencidoSum
        let xVencer07Cache = xVencer07
        let xVencer814Cache = xVencer814
        let xVencer1521Cache = xVencer1521
        let xVencer22Cache = xVencer22
        let totalSumCache = totalSum

        vencidoSum = 0
        xVencer07 = 0
        xVencer814 = 0
        xVencer1521 = 0
        xVencer22 = 0
        totalSum = 0
  
        console.log("Datarray", rowData);
        
        
        
        vencidoSum = vencidoSumCache + parseFloat(rowData.vencido.replace(/,/g, '')) 
        xVencer07 = xVencer07Cache + parseFloat(rowData.por_vencer.replace(/,/g, ''))
        xVencer814 = xVencer814Cache + parseFloat(rowData.por_vencer2.replace(/,/g, ''))
        xVencer1521 = xVencer1521Cache + parseFloat(rowData.por_vencer3.replace(/,/g, ''))
        xVencer22 = xVencer22Cache + parseFloat(rowData.por_vencer4.replace(/,/g, ''))
        totalSum = totalSumCache + Utils.strToNumber(rowData.saldo_total);
        console.log(vencidoSum);
        
      });

      if(!sumRows[key]) sumRows[key] = []; {

        sumRows[key].push({vencido: vencidoSum > 0 ? vencidoSum : '' , por_vencer07: xVencer07 > 0 ? xVencer07 : '' , por_vencer814: xVencer814 > 0 ? xVencer814 : '' , por_vencer1521: xVencer1521 > 0 ? xVencer1521 : ''  , por_vencer22: xVencer22 > 0 ? xVencer22 : '', saldo_total: totalSum > 0 ? totalSum : '' })
        
          console.log(sumRows[key]);
        
      }

      console.log("Suma de Saldos Vencidos:", vencidoSum);
      console.log(sumRows);
      
      totalsRow = <any>{
        folio:   '', 
        fechas:  '', 
        fechas2: '', 
        dias:    '', 
        dias2:   '', 
        vencido:     this.money((+sumRows[key][0].vencido).toFixed(2)),
        por_vencer:  this.money((+sumRows[key][0].por_vencer07).toFixed(2)), 
        por_vencer2: this.money((+sumRows[key][0].por_vencer814).toFixed(2)), 
        por_vencer3: this.money((+sumRows[key][0].por_vencer1521).toFixed(2)), 
        por_vencer4: this.money((+sumRows[key][0].por_vencer22).toFixed(2)), 
        saldo_total: this.money((+sumRows[key][0].saldo_total).toFixed(2))
      }

      // console.log("adsdad", totalsRow);
      
      // rows[key].push(totalsRow);
      if(!sumRow[key]) sumRow[key] = []; {

        sumRow[key].push(totalsRow)
        
          console.log(sumRow[key]);
        
      }
      

      }
      



      


    
    // folio: "2332", 
    //         fechas: '14/01/20', 
    //         fechas2: '21/03/20', 
    //         dias: "1",
    //         dias2: "3",
    //         vencido:"0.00", 
    //         por_vencer: "$234.00", 
    //         por_vencer2: "", 
    //         por_vencer3: "", 
    //         por_vencer4: "", 
    //         saldo_total: "$234.00"
    //        },
    
    
 
    PdfTemplates.Reports.CustomerBillExpiration(rows, sumRow)

  }

}
